import React from "react";
import { CertificatesBlock } from "ComponentsUIV2/Blocks";
import { HeaderTextSeo } from "ComponentsUI/SeoBlock";

import { pipe } from "Utils";
import { observer, inject } from "mobx-react";

const CertificatesContainer = (props) => {
	const { seoBlock } = props;

	return (
		<>
			<HeaderTextSeo header={seoBlock?.seoHeader} text={seoBlock?.seoText} />
			<CertificatesBlock />
		</>
	);
};

export default pipe(observer, inject("ApplicationModel"))(CertificatesContainer);
